import React, {useState, useEffect, useContext} from 'react';
import {labels} from '../../../../util/utils';
import Input from '../../../CoreWrappers/Input';
import {SVGICONS} from '@ey/icons';
import styled from 'styled-components';
import {GroupContext} from './Helper/GroupContext';
import * as groupActiontypes from './Helper/GroupActionTypes';

const AddNewDomain = (props) => {
	const [domainName, setDomainName] = useState('');
	const [showNameValidation, setShowNameValidation] = useState(false);
	const [duplicateValidation, setDuplicateValidation] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [invalidValidation, setInvalidValidation] = useState(false);

	const {state, dispatch} = useContext(GroupContext);

	const onInputChange = (e) => {
		if (!e.target.value || e.target.value.length > 100 || _.trim(e.target.value).length <= 0) {
			setInvalidValidation(true);
			props.setEmptyDomain(props.id, true);
			dispatch({type: groupActiontypes.SET_DOMAIN_EMPTY, payload: {id: props.id, isEmpty: true}});
		} else {
			props.setEmptyDomain(props.id, false);
			dispatch({type: groupActiontypes.SET_DOMAIN_EMPTY, payload: {id: props.id, isEmpty: false}});
			const validMessage = isValidDomainName(e.target.value.toLowerCase());
			if (validMessage !== '') {
				setInvalidValidation(true);
			} else {
				setInvalidValidation(false);
			}
		}
		setDomainName(_.trim(e.target.value.toLowerCase()));
	};

	useEffect(() => {
		if (domainName == '' && props.isOld) {
			const thisDomain = state.domains.find((d) => d.id == props.id);
			!_.isUndefined(thisDomain) ? setDomainName(thisDomain.domainName) : setDomainName('');
		}
	}, []);

	useEffect(() => {
		const showValidationError = invalidValidation || duplicateValidation;
		if (showValidationError !== showNameValidation) {
			setShowNameValidation(showValidationError);
		}
		dispatch({
			type: groupActiontypes.SET_VALID_INVALID_DOMAIN_DATA,
			attributes: {id: props.id, isValidDomainData: !showValidationError}
		});
	}, [invalidValidation, duplicateValidation]);

	useEffect(() => {
		let filteredList = props.domainList.filter((el) => el.id !== props.id);
		let defected = filteredList.some((el) => el.isEmpty == true || el.isDuplicate == true);

		if (defected) {
			setIsDisabled(true);
		} else setIsDisabled(false);
	}, [props.domainList]);

	const onOpen = () => {
		if (domainName == '') {
			setDomainName('@');
		}
	};

	useEffect(() => {
		if (props.domainError === true && domainName === '') {
			setShowNameValidation(true);
		}
	}, [props.domainError]);

	const isValidDomainName = (currval) => {
		let msg = '';
		const domainParts = currval.split('.');

		if (domainParts.length < 2) {
			msg = 'Atleast one dot required';
			return msg;
		}

		const wildcardReg = new RegExp(/(^(@\*)([A-Za-z0-9]{1,63})*$)|^(@{1,1})([A-Za-z0-9]{1,63})$/);
		const onlyWildcardReg = new RegExp(/^(@\*)$/);
		if (onlyWildcardReg.test(domainParts[0]) && domainParts.length < 3) {
			msg = 'If first part is a wild card, then it must have 2 or more part followed';
			return msg;
		}

		const generalReg = new RegExp(/^[A-Za-z0-9]{1,63}$/);

		if (!wildcardReg.test(domainParts[0])) {
			msg = 'First part can be * or alphanumeric, other special chars not allowed';
			return msg;
		}

		for (var i = 1; i < domainParts.length; i++) {
			if (!generalReg.test(domainParts[i])) {
				msg = 'Special chars not allowed, subdomain lenght must be 1-63!';
				break;
			}
		}
		return msg;
	};

	useEffect(() => {
		checkDuplicate(domainName, true);
	}, [state.domains]);

	const checkDuplicate = (e, isEffect) => {
		let found = false;
		if (domainName !== '') {
			if (isEffect) {
				found = state.domains.some((el) => el.domainName == e.toLowerCase() && el.id !== props.id);
			} else found = state.domains.some((el) => el.domainName == e.target.value.toLowerCase() && el.id !== props.id);
		}

		if (found) {
			setDuplicateValidation(true);
			props.setDomainDuplicate(props.id, true);
			dispatch({type: groupActiontypes.SET_DUPLICATE_VALIDATION, payload: {isDuplicate: true}});
		} else {
			setDuplicateValidation(false);
			props.setDomainDuplicate(props.id, false);
			dispatch({type: groupActiontypes.SET_DUPLICATE_VALIDATION, payload: {isDuplicate: false}});
		}
	};

	const getValidationErrorMessage = () => {
		if (duplicateValidation) {
			return labels.duplicateDomain;
		}

		if (invalidValidation) {
			const domainNamePart = _.trimStart(domainName, '@');
			return !domainNamePart ? labels.required : labels.invalidDomainName;
		}

		if(showNameValidation)
		{
			return labels.required;
		}

		return '';
	};

	return (
		<StyledDomainContainer className="add-new-domain-wrap" id={props.id}>
			<div className="group-input-textbox">
				<Input
					label={labels.domainName}
					id={props.id}
					maxLength="100"
					value={domainName}
					errorMessage={showNameValidation ? getValidationErrorMessage() : null}
					onFocus={onOpen}
					clearButtonTitle={labels.clearAllValues}
					onChange={(e) => {
						onInputChange(e);

						dispatch({type: groupActiontypes.UPDATE_DOMAIN_NAME, payload: {id: props.id, domainName: e.target.value}});
						checkDuplicate(e, false);
					}}
					disabled={isDisabled}
				/>
			</div>
			<span
				title={labels.clearAllValues}
				className="clearall"
				onClick={() => {
					props.remove(props.id);
					dispatch({type: groupActiontypes.REMOVE_DOMAIN_NAME, payload: {id: props.id}});
				}}
			>
				<SVGICONS styleName="medium" name={'close'} id={props.id} hoverText={labels.remove} alt="Clear" />
			</span>
		</StyledDomainContainer>
	);
};

export default AddNewDomain;

const StyledDomainContainer = styled.section`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	width: 35rem;
	position: relative;
	margin-bottom: 2rem;
	.group-input-textbox {
		width: 30rem;
		.motif-input {
			height: 4.4rem;
			padding: 2rem 0.5rem 0.8rem 1rem;
		}
		.motif-label-for-text {
			top: 1.5rem;
		}
		.motif-input-clear-button{
			top: 1.5rem;
			&:hover,
			&:focus{
				box-shadow: none !important;
			}
		}
		svg {
			&.small {
				width: 2rem;
				height: 2rem;
				max-width: 2rem;
				max-height: 2rem;
			}
		}
	}
	.clearall {
		margin: 0 1.5rem;
		height: 4.4rem;
		display: flex;
		align-items: center;
		svg {
			fill: ${(props) => props.theme.color[`black`]};
		}
	}
`;
